import Param from '../../param';
import effectManager from '../effect';
import Util from '../../util';
import MainVisual from './mainvisual';
import Panel from './panel';
// import Panel from './panel';


const param = new Param();
const effect = new effectManager();
const util = new Util();

export default class webglManager{
    constructor(){


        this.w = window.innerWidth;
        this.h = window.innerHeight;


        /* ftps低下時の対策 */
        this.time = 0;
        this.timeRatio = 1;
        this.FPS_60_SEC = 1000 / 60;

        this.timer = 0;

        this.pixelRato = window.devicePixelRatio;

        this.renderMode = "normal"; /* low || normal FPSが低下していたら切り替え */

        this.mainVisual = new MainVisual(this.w,this.h,this.pixelRato);
        // this.panel = new Panel(this.w,this.h,this.pixelRato);
        // this.panel = new Panel(this.pixelRato);


    }
    init(){
        // this.panel.init();
        // this.scene = new THREE.Scene();
        //
        // this.camera = new THREE.PerspectiveCamera(50, this.w / this.h, 1, 1000);
        // this.camera.updateProjectionMatrix();
        // this.camera.position.z = 1;
        // var _focus = new THREE.Vector3();
        // _focus.set( 0, 0, 0 );
        // this.camera.lookAt( _focus );
        //
        // // this.controls = new THREE.OrbitControls(this.camera);
        // // this.controls.autoRotate = true;
        //
        // this.renderer = new THREE.WebGLRenderer({
        //     alpha              : true,
        //     antialias          : true,
        //     // stencil            : false,
        //     // depth              : false,
        // });
        // this.renderer.setSize(this.w, this.h);
        // this.renderer.setClearColor(0xffffff,0);
        // this.renderer.setPixelRatio(this.pixelRato);
        // // this.renderer.autoClear = false;
        // document.getElementById('p-dark-bg').appendChild(this.renderer.domElement);

        this.mainVisual.init();
        // this.panel.init(this.scene,this.camera,this.renderer);

    }
    updateTimeRatio() {
        let _lastTime = this.time;
        if(_lastTime > 0) {
            let _dTime = new Date().getTime() - _lastTime;
            this.timeRatio = _dTime / this.FPS_60_SEC;
        }
        this.time = new Date().getTime();
    }
    render(mouse,current) {
        this.timer++;

        /* fpsが下がったら */
        if(this.timeRatio!==1){
            if(this.renderMode=="normal"){
                this.renderMode = "low";
                // this.renderer.setPixelRatio(1);
            }
        }else{
            if(this.renderMode=="low"){
                this.renderMode = "normal";
                // this.renderer.setPixelRatio(this.pixelRato);
            }
        }

        this.mainVisual.render(mouse,this.renderMode,current);
        // this.panel.render(mouse,this.renderMode);
        // this.renderer.render(this.scene, this.camera);

        // if(!renderTarget[0]||!this.mainVisual.loaded){
        //     if(this.timer%3!==1) return;
        //     this.mainVisual.render(mouse,this.renderMode);
        // }else{
        //     this.panel.render(renderTarget,this.renderMode)
        // }
    }
    resize(){
        this.w = window.innerWidth;
        this.h = window.innerHeight;
        // this.panel.resize();

        // if(this.camera===undefined) return;
        // this.camera.aspect = this.w / this.h;
        // this.camera.updateProjectionMatrix();
        // this.camera.position.z = this.h / Math.tan(this.camera.fov * Math.PI / 360) / 2;

        this.mainVisual.resize(this.w, this.h);
        // this.panel.resize(this.w, this.h);

        // this.renderer.setSize(this.w, this.h);
    }

    /* -------------------------------------------

      -- ステータスいじいじするやつ

    ------------------------------------------- */

    datGUI(){
        let _gui = new dat.gui.GUI();

        _gui.remember(effect);

        // console.log(createBg.uniforms);

        // var _f1 = _gui.addFolder('Mainvisual');
        // _f1.add(createBg.uniforms.opacity, 'value', 0.0, 1.0);
        // _f1.add(createBg.uniforms.bright, 'value', 0.0, 1.0);
        // _f1.add(createBg.uniforms.contrast, 'value', 0.0, 1.0);
        // _f1.add(this.camera.position, 'x', 0.0, 10.0);
        //

    }
}